export default "__VITE_ASSET__BM22n7wL__"